export type ActivityStatusIconProps = {
    status: 'complete' | 'pending' | 'denied'
    strokeWidth?: number
}

const ActivityStatusIcon = ({ status, strokeWidth = 2 }: ActivityStatusIconProps) => {
    switch (status) {
        case 'complete':
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.75 8L7.25 9.5L10.25 6.5M14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.27208 4.27208 1.25 8 1.25C11.7279 1.25 14.75 4.27208 14.75 8Z" stroke='#096F45' strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        case 'pending':
            return (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6V9L11.25 11.25M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z" stroke="#F2AF01" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        case 'denied':
            return (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5 13.5L13.5 4.5M4.5 4.5L13.5 13.5" stroke="#E7282D" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
    }
}

export default ActivityStatusIcon
